import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@retro-ia/shared/axios";

export interface ClienteFinalMetric {
  clienteFinalId: number;
  clienteFinalNombre: string;
  totalEntregas: number;
  totalInteraccionesIA: number;
  tiempoPromedioRespuestaIA: number | null;
}

export interface ClientesFinalesMetricsResponse {
  data: ClienteFinalMetric[];
}

export const useClientesFinalesMetrics = (params?: {
  clienteIntermedioId?: number;
  clienteFinalId?: number;
  programaId?: number;
  actividadId?: number;
  dateFrom?: string;
  dateTo?: string;
}) => {
  return useQuery<ClientesFinalesMetricsResponse, Error>({
    queryKey: ["clientesFinalesMetrics", params],
    queryFn: async () => {
      const response = await axiosInstance.get(
        "/analytics/clientes-finales/metrics",
        {
          params: {
            ...(params?.clienteIntermedioId && {
              clienteIntermedioId: params.clienteIntermedioId,
            }),
            ...(params?.clienteFinalId && {
              clienteFinalId: params.clienteFinalId,
            }),
            ...(params?.programaId && {
              programaId: params.programaId,
            }),
            ...(params?.actividadId && {
              actividadId: params.actividadId,
            }),
            ...(params?.dateFrom && { dateFrom: params.dateFrom }),
            ...(params?.dateTo && { dateTo: params.dateTo }),
          },
        }
      );
      return response.data;
    },

  });
};
